export const mapLocationToLink = ({ url, name }: { url: string; name: string; }) => ({
    href: url,
    text: name,
});

export const mapFilterValueToLink = ({ uri, label }: { uri: string; label: string; }) => ({
    href: uri,
    text: label,
});
